<div class="lmo-map">
  <div #map class="map"></div>
</div>
<sa-lmo-new-order-button class="new-order-button"></sa-lmo-new-order-button>
